import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomDatePicker = ({
  label,
  selected,
  onChange,
  required = false,
  className = "",
  dateFormat = "yyyy/MM/dd",
  placeholderText = "Select Date",
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label className="block text-sm font-normal text-slate-500 mb-1">
          {label}
          {required && <span className="text-red-500 text-xl">*</span>}
        </label>
      )}
      <DatePicker
        selected={selected}
        onChange={onChange}
        dateFormat={dateFormat}
        placeholderText={placeholderText}
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:border-flamingo-500 focus:ring-0 focus:outline-none transition-colors duration-200 bg-white text-sm`}
      />
    </div>
  );
};

export default CustomDatePicker;
